<template>
  <nav class="space-y-1" aria-label="Sidebar">
    <slot />
  </nav>
</template>
